import React, { useEffect } from "react";
import { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import logo from "../../assets/images/listen-aura-web-logo.webp";
import { IoCallOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;
  const [show, setShow] = useState(false);
  const [activeMenu, setActiveMenu] = useState(pathName || "/");

  useEffect(() => {
    setActiveMenu(pathName);
  }, [pathName]);

  const handleClose = () => setShow(false);
  const handleToggle = () => setShow(!show);

  // Navigate to a hash section. If already on "/", just smooth-scroll.
  const goTo = (id) => {
    const hash = `#${id}`;

    // If we're already on the Home page, scroll directly
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // fallback navigate so Home can scroll on mount
        navigate(`/${hash}`);
      }
    } else {
      // Navigate to Home with hash; Home will smooth-scroll on mount
      navigate(`/${hash}`);
    }

    handleClose();
  };

  return (
    <Navbar expand="lg" className="headerContainer" sticky="top">
      <Container>
        {/* Update the toggle to use your custom handler */}
        <Navbar.Toggle
          aria-controls={`offcanvasNavbar-expand-lg`}
          onClick={handleToggle}
        />
        <Navbar.Brand onClick={() => goTo("home")} className="navLogo">
          <img src={logo} />
        </Navbar.Brand>
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-lg`}
          aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
          placement="start"
          show={show}
          onHide={handleClose}
          className="customOffcanvasBelowHeader"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
              {/* <img src={logo}/> */}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="navLinks mx-auto">
              <Nav.Link onClick={() => goTo("home")}>Home</Nav.Link>
              <Nav.Link onClick={() => goTo("why")}>Why Listen Aura</Nav.Link>
              <Nav.Link onClick={() => goTo("how")}>How It Works</Nav.Link>
              <Nav.Link onClick={() => goTo("services")}>Services</Nav.Link>
              <Nav.Link onClick={() => goTo("testimonials")}>
                Testimonials
              </Nav.Link>

              <Nav.Link onClick={() => goTo("contact")}>Contact Us</Nav.Link>
            </Nav>
            <Nav>
              <div>
                <Link to="/become-a-listener">
                  <button className="btnBecomeListener">
                    Become a Listener
                  </button>
                </Link>
              </div>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};
